import React from "react";
import "./BlogCard.css";

export default function BlogCard({ post, onClick }) {
  const { title, excerpt, category, author, date, coverUrl } = post;
  return (
    <div className="blog-card" onClick={onClick}>
      {coverUrl ? (
        <img src={coverUrl} className="blog-card-img" alt={title} />
      ) : (
        <div className="blog-card-img blog-card-img--placeholder">📰</div>
      )}
      <div className="blog-card-body">
        {category && <div className="blog-card-category">{category}</div>}
        <div className="blog-card-title">{title}</div>
        <div className="blog-card-excerpt">{excerpt}</div>
        <div className="blog-card-footer">
          <span className="blog-card-author">{author || "Kedrick Scribner"}</span>
          <span className="blog-card-date">{date}</span>
        </div>
      </div>
    </div>
  );
}
